import { ODListableResponseType } from '@odc/od-react-belt'
import React from 'react'
import { GQLFeatured } from '../../../@types/server'
import { useStoryPlayAPIs } from '../../../hooks/useStoryPlayAPIs'
import { IFeaturedListableOption } from '../FeturedCommon'

export function useFeaturedListDataLoader() {
  const { listFeatured } = useStoryPlayAPIs()
  return React.useCallback(
    async function dataLoader(
      page: number,
      pageSize: number,
      afterKey: string | null,
      options: IFeaturedListableOption
    ): Promise<ODListableResponseType<GQLFeatured>> {
      const r = await listFeatured({
        page,
        pageSize: 100,
        ...options,
      })
      return r as ODListableResponseType<GQLFeatured>
    },
    [listFeatured]
  )
}
